import type {
  BaseComponentProps,
  ContentfulLinkType,
  ContentfulNavigationType,
} from '@bedrock/core/contentful';
import { SheetClose } from '@bedrock/ui/sheet';
import { cn } from '@bedrock/ui/utils';
import { NavigationLink } from './navigation-link';

type UtilityLinksProps = {
  utilityLinks?: (ContentfulLinkType | ContentfulNavigationType)[];
  breadcrumbs: ContentfulNavigationType[];
} & Pick<BaseComponentProps, 'locale'>;

export default function UtilityLinks({
  breadcrumbs,
  locale,
  utilityLinks,
}: Readonly<UtilityLinksProps>) {
  if (!utilityLinks?.length) return null;

  return (
    <li className="patterns-navigation-hamburger-utility mt-4xl">
      <ul className="patterns-navigation-hamburger-utility-items gap-xs flex flex-col">
        {utilityLinks
          .filter((item) => item.sysType === 'link')
          .map((link, index) => (
            // eslint-disable-next-line react/no-array-index-key -- Contentful may return duplicate sysId entries
            <li key={`${link.sysId}-${index}`}>
              <SheetClose asChild>
                <NavigationLink
                  className={cn('patterns-navigation-hamburger-utility-link text-foreground')}
                  link={link}
                  locale={locale}
                  size="sm"
                  tabIndex={breadcrumbs.length > 0 ? -1 : undefined}
                  variant="underline"
                >
                  {link.label}
                </NavigationLink>
              </SheetClose>
            </li>
          ))}
      </ul>
    </li>
  );
}
